<template>
  <div style="width: 100%; margin: auto; position: relative; top: -10px">
    <v-select
      v-model="status"
      hide-details
      :items="[
        'Enquiry',
        'In Progress',
        'Completed',
        'Fallen Through',
        'Introduction',
      ]"
      @change="updateStatus()"
      hide-details
    >
    </v-select>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      status: "",
    }),
    watch: {
      params: function () {
        this.status = this.params.data.upstreamStatus;
      },
    },
    beforeCreate() {},
    mounted() {
      this.status = this.params.data.upstreamStatus;
    },
    methods: {
      updateStatus() {
        let payload = this.params.data;
        payload.upstreamStatus = this.status;
        this.$store.dispatch("business/salesEnquirySaveNoReload", payload);
      },
    },
  };
</script>

